import { useContext } from 'react';
import { ProceduresChartsDataContext } from '../contexts/ProceduresChartsDataContext';

export const useProceduresChartsDataContext = () => {
    return useContext(ProceduresChartsDataContext);
};
